import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { reloadNow } from '../../../app/actions.web';
import Button from '../../../base/ui/components/web/Button';
const useStyles = makeStyles()(theme => {
    return {
        button: {
            background: 'white',
            color: '#667eea',
            padding: '8px 20px',
            fontSize: '0.875rem',
            fontWeight: 600,
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            whiteSpace: 'nowrap',
            '&:hover': {
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                background: '#f8f9fa'
            },
            '&:active': {
                transform: 'translateY(0)',
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)'
            },
            '@media (max-width: 768px)': {
                padding: '8px 16px',
                fontSize: '0.8125rem',
                width: '100%'
            }
        }
    };
});
const ReloadButton = ({ textKey }) => {
    const dispatch = useDispatch();
    const { classes } = useStyles();
    const onClick = useCallback(async () => {
        // Set flag to auto-rejoin after reload (connection was lost, user wants to rejoin)
        localStorage.setItem("shouldAutoRejoin", "true");
        dispatch(reloadNow());
    }, [dispatch]);
    return (React.createElement(Button, { className: classes.button, labelKey: textKey, onClick: onClick }));
};
export default ReloadButton;
